module.exports = __webpack_public_path__ + "static/media/settings.0cca3138.svg";